import * as React from "react"
import { Toaster as Sonner } from "sonner"
import { cn } from "@/lib/utils"

type ToasterProps = React.ComponentProps<typeof Sonner>

const toasterClassNames = {
  toast: "group toast rounded-lg border border-border bg-background text-foreground shadow-lg",
  title: "text-sm font-medium",
  description: "text-sm text-muted-foreground",
  closeButton:
    "border-0 bg-transparent text-muted-foreground opacity-100 hover:bg-muted hover:text-foreground",
  actionButton: "bg-primary text-primary-foreground",
  cancelButton: "bg-muted text-muted-foreground",
}

const Toaster = ({ className, toastOptions, ...props }: ToasterProps) => {
  return (
    <Sonner
      theme="light"
      className={cn("toaster group", className)}
      toastOptions={{
        ...toastOptions,
        classNames: {
          ...toasterClassNames,
          ...toastOptions?.classNames,
        },
      }}
      {...props}
    />
  )
}

export { Toaster }
